import { render, staticRenderFns } from "./Forget_password.vue?vue&type=template&id=2b4e8ebe&scoped=true&"
import script from "./Forget_password.vue?vue&type=script&lang=js&"
export * from "./Forget_password.vue?vue&type=script&lang=js&"
import style0 from "./Forget_password.vue?vue&type=style&index=0&id=2b4e8ebe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4e8ebe",
  null
  
)

export default component.exports